export default __webpack_public_path__ + "static/media/diagram-en-desktop.6c4e945e.jpg";